<template>
  <v-card class="rsl-fixed-height-external">
    <v-container>
      Form completed, thank you for your time.
    </v-container>
  </v-card>
</template>

<script>

export default {
  name: 'thankyou',
  data: function() {
    return {

    }
  },
}
</script>